
document.addEventListener('DOMContentLoaded', () => {
    const table = document.querySelector('[data-services-table]');
    const searchInput = document.querySelector('[data-service-search]');

    if (!table) return;

    // ── 1. Tek seferlik DOM cache ────────────────────────────────
    const serviceRows      = Array.from(table.querySelectorAll('[data-service-row]'));
    const categoryRows     = Array.from(table.querySelectorAll('[data-service-category]'));
    const toggleButtons    = Array.from(table.querySelectorAll('[data-service-toggle]'));
    const emptyRow         = table.querySelector('[data-services-empty]');

    // ── 2. O(1) Map'ler — querySelectorAll döngüsü yok ──────────
    const descriptionMap = new Map(); // serviceId → descriptionRow
    table.querySelectorAll('[data-service-description]').forEach(row => {
        descriptionMap.set(row.dataset.serviceDescription, row);
    });

    const categoryServicesMap = new Map(); // categoryName → serviceRow[]
    serviceRows.forEach(row => {
        const cat = row.dataset.categoryName;
        if (!categoryServicesMap.has(cat)) categoryServicesMap.set(cat, []);
        categoryServicesMap.get(cat).push(row);
    });

    const buttonMap = new Map(); // serviceId → toggleButton
    toggleButtons.forEach(btn => buttonMap.set(btn.dataset.serviceToggle, btn));

    // ── 3. Normalize (TR locale) ─────────────────────────────────
    const normalize = v => v.toString().toLocaleLowerCase('tr-TR').trim();

    // ── 4. Servis meta verisini cache'le (search'te string birleştirme yok) ──
    const serviceMetaCache = serviceRows.map(row => ({
        row,
        id:       normalize(row.dataset.serviceId   || ''),
        name:     normalize(row.dataset.serviceName  || ''),
        category: normalize(row.dataset.categoryName || ''),
        rawId:    row.dataset.serviceId,
    }));

    // ── 5. Toggle yardımcıları ───────────────────────────────────
    const setButtonState = (button, isOpen) => {
        button.querySelector('[data-service-toggle-open-text]')?.classList.toggle('hidden', isOpen);
        button.querySelector('[data-service-toggle-close-text]')?.classList.toggle('hidden', !isOpen);
        button.querySelector('i')?.classList.toggle('rotate-180', isOpen);
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    };

    const closeAllDescriptions = () => {
        descriptionMap.forEach(row => row.classList.add('hidden'));
        buttonMap.forEach(btn  => setButtonState(btn, false));
    };

    // ── 6. Click handler (değişmedi, zaten O(1)) ─────────────────
    table.addEventListener('click', event => {
        const button = event.target.closest('[data-service-toggle]');
        if (!button) return;

        const serviceId      = button.dataset.serviceToggle;
        const descriptionRow = descriptionMap.get(serviceId);
        if (!descriptionRow) return;

        const willOpen = descriptionRow.classList.contains('hidden');
        closeAllDescriptions();

        if (willOpen) {
            descriptionRow.classList.remove('hidden');
            setButtonState(button, true);
        }
    });

    if (!searchInput) return;

    // ── 7. Kategori ve boş durum güncelleme (Map tabanlı) ────────
    const refreshCategories = () => {
        categoryRows.forEach(catRow => {
            const services = categoryServicesMap.get(catRow.dataset.categoryName) || [];
            const hasVisible = services.some(r => !r.classList.contains('hidden'));
            catRow.classList.toggle('hidden', !hasVisible);
        });
    };

    const refreshEmptyState = () => {
        if (!emptyRow) return;
        const hasVisible = serviceRows.some(r => !r.classList.contains('hidden'));
        emptyRow.classList.toggle('hidden', hasVisible);
    };

    let debounceTimer = null;
    let rafHandle     = null;

    searchInput.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            const query = normalize(searchInput.value);

            closeAllDescriptions();

            if (rafHandle) cancelAnimationFrame(rafHandle);
            rafHandle = requestAnimationFrame(() => {
                serviceMetaCache.forEach(({ row, id, name, category, rawId }) => {
                    const matches = !query ||
                        id.includes(query) ||
                        name.includes(query) ||
                        category.includes(query);

                    row.classList.toggle('hidden', !matches);
                    descriptionMap.get(rawId)?.classList.add('hidden');
                });

                refreshCategories();
                refreshEmptyState();
            });
        }, 150);
    });
});